import { useCallback, useState } from "react";
import { Image as ImageIcon, RefreshCw } from "lucide-react";
import MediaLibraryPicker from "../../components/media/MediaLibraryPicker";
import { api } from "../../services/api";
import { ToastStack, useToast } from "./useToast";

export default function MediaLibrary() {
  const [refreshing, setRefreshing] = useState(false);
  const { dismiss, toast, toasts } = useToast();

  const refreshExisting = useCallback(async () => {
    setRefreshing(true);
    try {
      const data = await api.post("/media/assets/refresh", {});
      toast(data.message || "Media refresh started", "success");
    } catch (err) {
      toast(err.message, "error");
    } finally {
      setRefreshing(false);
    }
  }, [toast]);

  return (
    <div className="space-y-6">
      <ToastStack dismiss={dismiss} toasts={toasts} />
      <section className="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-50 text-[#4391d1]">
              <ImageIcon size={22} />
            </span>
            <div>
              <p className="text-xs font-black uppercase tracking-widest text-[#4391d1]">Website Assets</p>
              <h1 className="mt-1 text-2xl font-black text-gray-900">Media Library</h1>
              <p className="mt-2 max-w-2xl text-sm font-semibold leading-6 text-gray-500">
                Manage reusable product, category, and CMS images with titles, captions, descriptions, and alt text.
              </p>
            </div>
          </div>
          <button
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-gray-200 px-4 py-3 text-sm font-black text-gray-700 hover:border-[#4391d1] hover:text-[#4391d1]"
            disabled={refreshing}
            onClick={refreshExisting}
            type="button"
          >
            <RefreshCw className={refreshing ? "h-4 w-4 animate-spin" : "h-4 w-4"} />
            Refresh Existing Images
          </button>
        </div>
      </section>

      <section className="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-lg font-black text-gray-900">Open Library Manager</h2>
            <p className="mt-1 text-sm font-semibold text-gray-500">
              Upload new media or edit details for images already used on the website.
            </p>
          </div>
          <MediaLibraryPicker
            buttonLabel="Open Media Library"
            folder="media"
            multiple
            source="media_library"
            onSelect={(urls) => toast(`${urls.length} image${urls.length === 1 ? "" : "s"} selected`, "success")}
          />
        </div>
      </section>
    </div>
  );
}
